<div class="outer-container">
  <div class="loading-container">
    <div class="inner">
      <div class="logo">
        <app-animated-primus-logo></app-animated-primus-logo>
      </div>

      <mat-spinner diameter="24"/>

      <p class="spinner-alternative">
        {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
      </p>

      @if (currentStep()) {
        <p [@fadeInOut]="currentStep()">
          {{ (currentStep() | translate) || 'Loading...' }}
        </p>
      }

      @if (infoMessageKey) {
        <p class="info-message">
          {{ infoMessageKey | translate }}
        </p>
      }

      @if (actionLabelKey) {
        <button
          mat-button
          type="button"
          class="action-link"
          (click)="onActionClick()"
        >
          {{ actionLabelKey | translate }}
        </button>
      }
    </div>
  </div>
</div>
